import { HStack } from '@chakra-ui/react'
import type { FC, PropsWithChildren } from 'react'
import { Link } from 'react-router-dom'

import ConfidenceRatingPopover from '@app/next/confidenceRatingPopover'
import OwnerPopover from '@app/next/ownerPopover'
import CommentsCount from '@app/pages/strategies/components/nodes/components/commentsCount'
import cardAvatarSize from '@app/shared/cards/cardAvatarSize'
import cardFontSize from '@app/shared/cards/cardFontSize'
import CardSection from '@app/shared/cards/components/cardSection'
import type { CardSize, DomainObject } from '@app/types'

type Props = {
  domainObject: DomainObject & {
    commentsCount?: number
  }
  size: CardSize
  includeConfidenceRating?: boolean
  route?: string | null
}

const CardSharedActions: FC<PropsWithChildren<Props>> = ({
  domainObject,
  size,
  children,
  includeConfidenceRating = true,
  route = null
}) => {
  const { commentsCount } = domainObject
  const avatarSize = cardAvatarSize('xs', size)
  const fontSize = cardFontSize('sm', size)

  const commentBubble = <CommentsCount commentsCount={commentsCount} showWhenNoComments size="lg" />
  const commentsDisplay = route ? <Link to={`${route}/comments`}>{commentBubble}</Link> : commentBubble

  return (
    <CardSection size={size}>
      <HStack gap={1}>
        <OwnerPopover fontSize={fontSize} object={domainObject} avatarProps={{ size: avatarSize, mr: 2 }} />
        {includeConfidenceRating && (
          <ConfidenceRatingPopover domainObject={domainObject} fontSize={fontSize} size={size} />
        )}
        {commentsDisplay}
        {children}
      </HStack>
    </CardSection>
  )
}

export default CardSharedActions
